import { Listing } from "components/Listing"
import MassAttributeReplace from "pages/MassAttributeReplace"
import MassGeneration from "pages/Nomenclature/MassGeneration"
import { NomenclatureDetail } from "pages/Nomenclature/NomenclatureDetail"
import { CreateRouteData } from "./tools"
import GeneralConfiguratorWrapper from "pages/Configuration/GeneralConfigurator/GeneralConfiguratorWrapper"

export const configuratorRoutes: CreateRouteData[] = [
    {
        path: "configurator",
        title: "Конфигуратор",
        render: () => <GeneralConfiguratorWrapper />,
        permission: "configuration/configurator",
        dontShowInMenu: true,
    },
    {
        path: "configurator-iframe",
        title: "Конфигуратор",
        render: () => <GeneralConfiguratorWrapper isIframe />,
        permission: "configuration/configurator",
        dontShowInMenu: true,
    },
    {
        path: "configurator-collections",
        title: "Конфигуратор на базе коллекций",
        render: () => <GeneralConfiguratorWrapper useCollections />,
        permission: "configuration/configurator",
        dontShowInMenu: true,
    },
    {
        path: "configurator-collections-iframe",
        title: "Конфигуратор на базе коллекций",
        render: () => <GeneralConfiguratorWrapper useCollections isIframe />,
        permission: "configuration/configurator",
        dontShowInMenu: true,
    },
    {
        path: "nomenclature",
        title: "Номенклатуры",
        render: () => <Listing />,
        createAndUpdate: () => <NomenclatureDetail />,
        dontShowInMenu: true,
    },
    {
        path: "mass-generation",
        title: "Генератор номенклатур",
        render: () => <MassGeneration />,
        dontShowInMenu: true,
    },
    {
        path: "attribute-replace",
        title: "Замена свойств",
        render: () => <MassAttributeReplace />,
        dontShowInMenu: true,
    },
]
